import apiClient from "../../axios/apiClient";


export const getDriverList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_DRIVERLIST_PENDING" });

      const response = await apiClient.get(
        `/api/v1/drivers`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_DRIVERLIST_FULFILLED",
        payload: response.data?.data,
        driverCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      dispatch({
        type: "GET_DRIVERLIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveDriverData = (token, data) => async (dispatch) => {
    try {
      dispatch({ type: "ADD_DRIVER_PENDING" });
  
      const response = await apiClient.post(
        `/api/v1/drivers`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_DRIVER_FULFILLED", payload: response.data });
    } catch (error) {
      dispatch({ type: "ADD_DRIVER_REJECTED", payload: error.response });
    }
  };
  

  export const getDriverListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_DRIVERLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/v1/drivers/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_DRIVERLISTBYID_FULFILLED",
        payload: response.data?.data,
        driverCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_DRIVERLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateDriverData = (token, data, id) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_DRIVER_PENDING" });

    const response = await apiClient.put(
      `/api/v1/drivers/${id}`, // Endpoint URL with City ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_DRIVER_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_DRIVER_REJECTED", payload: error.response });
  }
};

export const updateDriverStatusData = (token, id, status) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_DRIVER_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.put(
      `/api/v1/drivers/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_DRIVER_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_DRIVER_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteDriverData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_DRIVER_PENDING" });

    const response = await apiClient.delete(
      `/api/v1/drivers/${id}`, // Endpoint URL with City ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_DRIVER_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_DRIVER_REJECTED", payload: error.response });
  }
};


export const logoutDriverDevice =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "LOGOUT_DRIVER_DEVICE_PENDING" });
      const data={
        "status":"Active"
      }
      const response = await apiClient.post(
        `/api/admin/v1/Logout-Driver/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "LOGOUT_DRIVER_DEVICE_FULFILLED",
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: "LOGOUT_DRIVER_DEVICE_REJECTED",
        payload: error.response,
      });
    }
  };


export const resetDriverRegistrationStatus = (token, id, status ) => async (dispatch) => {
  try {
    dispatch({ type: "RESET_DRIVER_REGISTRATION_PENDING" });
    const data = { isRegistration: status };
    const response = await apiClient.post(
      `/api/v1/drivers/${id}/reset-registration`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "RESET_DRIVER_REGISTRATION_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "RESET_DRIVER_REGISTRATION_REJECTED", payload: error.response });
  }
};

export const uploadDriverPhoto = (token, id, photo) => async (dispatch) => {
  try {
    dispatch({ type: "ADD_DRIVER_PHOTO_PENDING" });
    const formData = new FormData();
    formData.append("file", photo);
    const response = await apiClient.post(
      `/api/v1/drivers/${id}/photo`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    dispatch({ type: "ADD_DRIVER_PHOTO_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "RESET_DRIVER_PHOTO_REJECTED", payload: error.response });
  }
};
      